interface IconProps {
  fillColor: string
}

export const IdentityVerificationFailedIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        aria-hidden="true"
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.0694 29.5332C38.3587 29.5332 34.5399 33.352 34.5399 38.0627C34.5399 42.7735 38.3587 46.5923 43.0694 46.5923C47.7802 46.5923 51.599 42.7735 51.599 38.0627C51.599 33.352 47.7802 29.5332 43.0694 29.5332ZM36.8066 38.0627C36.8066 34.6039 39.6105 31.7999 43.0694 31.7999C46.5283 31.7999 49.3323 34.6039 49.3323 38.0627C49.3323 41.5216 46.5283 44.3256 43.0694 44.3256C39.6105 44.3256 36.8066 41.5216 36.8066 38.0627Z"
          fill={fillColor}
        />
        <path
          d="M61.068 59.1985C60.6254 58.7559 59.9078 58.7559 59.4652 59.1985C59.0226 59.6411 59.0226 60.3587 59.4652 60.8013L66.3305 67.6665L59.4652 74.5318C59.0226 74.9744 59.0226 75.692 59.4652 76.1346C59.9078 76.5772 60.6254 76.5772 61.068 76.1346L67.9333 69.2693L74.7986 76.1346C75.2412 76.5772 75.9588 76.5772 76.4013 76.1346C76.8439 75.692 76.8439 74.9744 76.4013 74.5318L69.5361 67.6665L76.4013 60.8013C76.8439 60.3587 76.8439 59.6411 76.4013 59.1985C75.9588 58.7559 75.2412 58.7559 74.7986 59.1985L67.9333 66.0638L61.068 59.1985Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.1258 44.8787C61.8637 44.8787 56.1915 47.4039 52.0717 51.4915C52.0485 51.4716 52.0242 51.4524 51.999 51.4341C49.5018 49.6222 46.4105 48.5521 43.0692 48.5521C35.5276 48.5521 29.257 54.0047 28.212 61.1439C28.1213 61.7632 28.5499 62.3388 29.1692 62.4294C29.7885 62.5201 30.3641 62.0915 30.4548 61.4722C31.3335 55.4689 36.6295 50.8188 43.0692 50.8188C45.8617 50.8188 48.4396 51.6934 50.5362 53.1745C47.2851 57.1144 45.3321 62.1653 45.3321 67.6724C45.3321 80.261 55.5372 90.466 68.1258 90.466C80.7144 90.466 90.9194 80.261 90.9194 67.6724C90.9194 55.0838 80.7144 44.8787 68.1258 44.8787ZM47.5988 67.6724C47.5988 56.3356 56.789 47.1454 68.1258 47.1454C79.4625 47.1454 88.6528 56.3356 88.6528 67.6724C88.6528 79.0091 79.4625 88.1994 68.1258 88.1994C56.789 88.1994 47.5988 79.0091 47.5988 67.6724Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
